import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import ConditionalTooltip from '../../../../conditionalTooltip';
import ActionButton from '../../../../actionButton';
import { ellipsis } from '../../../../../../constants/helperCssRules';
import { ACTION_BUTTON_TYPES } from '../../../../actionButton/config';

const useStyles = makeStyles(({ spacing }) => ({
  value: {
    ...ellipsis(),
  },
  actionCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  highlighted: {
    fontFamily: 'ProximaNova-Bold',
  },
  expandButton: {
    marginLeft: spacing(1.5),
  },
  expandIcon: {
    transform: 'rotate(0deg)',
    transition: 'transform .3s cubic-bezier(0.77, 0.2, 0.05, 1)',
  },
  expandIconOpened: {
    transform: 'rotate(180deg)',
  },
}));

const Cell = ({
  translations,
  value,
  column,
  position,
  isDisabled = false,
  isHighlighted = false,
  shouldShowTooltip = false,
  isExpanded,
  getCellRef,
  onToggleExpand,
}) => {
  const classes = useStyles();

  return (
    <ConditionalTooltip addTooltip={shouldShowTooltip} message={value || ''}>
      <Typography
        component="div"
        ref={ref =>
          getCellRef(ref, position, column.rowKey, column.hasConditionalTooltip)
        }
        className={classNames(
          'row-cell-value',
          classes.value,
          {
            [classes.actionCell]: column.isHeaderAction,
          },
          {
            [classes.highlighted]: isHighlighted,
          },
          column.cellValueClass
        )}
      >
        {value}
        {column.isHeaderAction && (
          <ActionButton
            className={classes.expandButton}
            type={ACTION_BUTTON_TYPES.ARROW}
            iconClass={classNames(classes.expandIcon, {
              [classes.expandIconOpened]: isExpanded,
            })}
            tooltipText={translations.expandTooltip}
            disabledTooltipText={translations.expandTooltipDisabled}
            isDisabled={isDisabled}
            onClickHandler={onToggleExpand}
          />
        )}
      </Typography>
    </ConditionalTooltip>
  );
};

Cell.propTypes = {
  value: PropTypes.node.isRequired,
  column: PropTypes.object.isRequired,
  position: PropTypes.number.isRequired,
  isHighlighted: PropTypes.bool,
  shouldShowTooltip: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isExpanded: PropTypes.bool.isRequired,
  getCellRef: PropTypes.func.isRequired,
  onToggleExpand: PropTypes.func.isRequired,
};

export default Cell;
